import { render, staticRenderFns } from "./AnnotationLinkSelector.vue?vue&type=template&id=1c3371b2&scoped=true&"
import script from "./AnnotationLinkSelector.vue?vue&type=script&lang=js&"
export * from "./AnnotationLinkSelector.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationLinkSelector.vue?vue&type=style&index=0&id=1c3371b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3371b2",
  null
  
)

export default component.exports